<template>
    <!-- 签到奖励 -->
    <div v-if="giftList.length > 0"
        :class="['sign-in-reward',checkinCategory ===CHECK_IN_CATEGORY.REGULAR_CHECK_IN ?(isExpend ? 'margin-expand' :'margin-collapse'): 'margin-offline']">
        <div v-for="(item, index) in giftList"
            :key="index"
            class="sign-in-reward-list">
            <div class="gift-type ellipsis-text">
                {{ item.taskName || "" }}
            </div>
            <div class="reward-info">
                <img v-if="item.picUrl"
                    :src="getPicUrl(item.picUrl)" />
                <img v-else
                    src="static/runtime/images/magic/signIn/noAwardDefault.png" />
                <div class="gift-info">
                    <div class="gift-title">
                        {{ item.rewardTitle }}{{ getRewardTitleInfo(item) }}
                    </div>
                    <div class="gift-item">
                        <div>
                            <div class="gift-name">
                                {{ item.rightsName }}
                            </div>
                            <div class="gift-time">
                                {{ getGiftTime(item) }}
                            </div>
                        </div>
                        <div class="button-item"
                            :class="getButtonClass(item)"
                            :style="item.status === 3 && item.rewardSettingType !== '3' ? 'min-width:104px' : 'min-width:70px'"
                            @click="goUse(item)">
                            {{ getGiftStatus(item) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 无签到奖励背景 -->
    <div v-else
        :class="['no-gift',checkinCategory ===CHECK_IN_CATEGORY.REGULAR_CHECK_IN ?'no-gift-ordinary': 'no-gift-offline']">
        <img src="static/runtime/images/magic/signIn/sign-in-no-gift.png" />
        {{ noGift }}
    </div>
</template>
<script>
import { Popup } from 'vant';
import { SignInGiftStatus, SignInTaskType, GoodsType, CHECK_IN_CATEGORY } from '../../../../commons/commonVariables';
export default {
  name: 'GiftList',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    giftList: {
      type: Array,
      default: [],
    },
    noGift: {
      type: String,
      default: '',
    },
    isLoginFlag: {
      type: Boolean,
      default: false,
    },
    isExpend: {
      type: Boolean,
      default: false,
    },
    // activityType 12 checkinCategory 0普通签到(旧的线上签到)
    // activityType 12 checkinCategory 2线下签到
    // activityType 21 checkinCategory 1线上预约线下签到
    checkinCategory: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      popupVisible: false,
      refreshTimer: '',
      CHECK_IN_CATEGORY: CHECK_IN_CATEGORY,
    };
  },
  watch: {
    giftList(newValue) {
      this.giftList = newValue;
    },
  },
  methods: {
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    getRewardTitleInfo(item) {
      let text = '';
      if (item.rewardSettingType === '0') {
        text = `（已连续签到${item.checkinDays}天）`;
      }
      if (item.rewardSettingType === '1') {
        text = `（已累计签到${item.checkinTotalDays}天）`;
      }
      return text;
    },
    // 格式化奖品有效期
    getGiftTime(item) {
      let startDate = '';
      let endDate = '';
      if (item && item.startDate) {
        const tmp = item.startDate.split(' ')[0];
        if (tmp) {
          startDate = tmp.replace(/-/gi, '.');
        }
      }
      if (item && item.endDate) {
        const tmp = item.endDate.split(' ')[0];
        if (tmp) {
          endDate = tmp.replace(/-/gi, '.');
        }
      }
      if (startDate === endDate) {
        return `${startDate}`;
      } else {
        return `${startDate} - ${endDate}`;
      }
    },
    getButtonClass(item) {
      let className = '';
      switch (item.status) {
        case 0:
        case 1:
        case 3:
        case 4:
        case 6:
          className = 'conditions-disabled';
          break;
        case 5:
          className = 'to-finish';
          break;
        case 2:
          className = 'to-use';
          break;
        default:
          break;
      }

      if (!this.isLoginFlag) {
        className = 'conditions-disabled';
      }
      if (item.rewardSettingType === SignInTaskType.offlineStoreCheckIn && item.status === SignInGiftStatus.notMeetConditions) {
        className = 'to-finish';
      }
      return className;
    },
    goUse(item) {
      this.$emit('goUse', item);
    },
    getGiftStatus(item) {
      // 奖项状态 0、未开始 1、已使用 2、 去使用  3、未达到条件 4、已领完 5、待领取 6、已过期
      let type = '';
      switch (item.status) {
        case 0:
          type = '未开始';
          break;
        case 1:
          type = '已使用';
          break;
        case 2:
          type = '去使用';
          break;
        case 3:
          type = '未达领取条件';
          break;
        case 4:
          type = '已领完';
          break;
        case 5:
          type = '待领取';
          break;
        case 6:
          type = '已过期';
          break;
        default:
          break;
      }
      if (item.rewardSettingType === SignInTaskType.offlineStoreCheckIn) {
        if (item.status === SignInGiftStatus.notMeetConditions) {
          type = '去完成';
        } else if (item.rewardType === GoodsType.noAward) {
          if (item.jumpUrl) {
            type = '去参与';
          } else {
            type = '已完成';
          }
        }
      }
      return type;
    },
  },
};
</script>
<style lang="scss" scoped>
.sign-in-reward {
  background: #f8f8f8;
  box-shadow: 0 0 12px 8px rgba(162, 162, 162, 0.07);
  width: 92%;
  margin: 0 auto;
}
.margin-expand {
  margin-top: 212px;
}
.margin-collapse {
  margin-top: -90px;
}
.margin-offline {
  margin-top: -55px;
}
.sign-in-reward {
  .sign-in-reward-list:first-child {
    margin-top: 72px;
  }
  .sign-in-reward-list:last-child {
    margin-bottom: 22.5px;
  }
}
.sign-in-reward-list {
  background: #ffffff;
  border-radius: 10px;
  // height: 130px;
  margin-top: 10px;
  padding: 10px 15px;
  .gift-type {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 500;
  }
  .reward-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
    img {
      height: 16.133vw;
      width: 16.133vw;
    }
    .gift-info {
      margin-left: 20px;
      width: 100%;
      .gift-item {
        display: flex;
        align-items: flex-end;
        width: 100%;
        justify-content: space-between;
      }
      .gift-title {
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        font-weight: 400;
      }
      .gift-name {
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
      .gift-time {
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .button-item {
      height: 30px;
      border-radius: 15px;
      padding: 0px 16px;
      text-align: center;
      line-height: 30px;
      font-size: 12px;
    }
    .to-finish {
      background: #256fff;
      color: #ffffff;
    }
    .to-use {
      border: 1px solid #256fff;
      color: #256fff;
    }
    .conditions-disabled {
      background: #e0e0e0;
      color: #ffffff;
    }
  }
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证不换行 */
}
.no-gift {
  margin-top: 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #c3c3c3;
  letter-spacing: 0;
  font-weight: 400;
  img {
    width: 50%;
  }
}
.no-gift-ordinary {
  margin-top: 20px;
}
.no-gift-offline {
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in-components/gift-list.vue